/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Review_Category_ContentInputs */

const en_cv_review_category_content = /** @type {(inputs: Cv_Review_Category_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content & Structure`)
};

const de_cv_review_category_content = /** @type {(inputs: Cv_Review_Category_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt & Struktur`)
};

/**
* | output |
* | --- |
* | "Content & Structure" |
*
* @param {Cv_Review_Category_ContentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_review_category_content = /** @type {((inputs?: Cv_Review_Category_ContentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Review_Category_ContentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_review_category_content(inputs)
	return en_cv_review_category_content(inputs)
});